import styles from "./MaterialUnavailable.module.scss";
import { FormattedMessage } from "react-intl";
import { clsx } from "clsx";

export default function MaterialUnavailable() {
  return (
    <div data-testid="material-unavailable">
      <div className={clsx("vst-tag vst-tag-size-small vst-tag-variant-cloud")}>
        <FormattedMessage defaultMessage={"Unavailable"} />
      </div>
      <div className={styles.message}>
        <FormattedMessage
          defaultMessage={
            "This item is currently unavailable for purchase in our store."
          }
        />
      </div>
    </div>
  );
}
